import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../constants/colors.constants';

export const photoStyles = (
	src: string | null | undefined = '',
	withWrapper?: boolean,
	{
		width = 90,
		height,
		maxWidth = width,
		maxHeight = height,
	}: { maxWidth?: number; width?: number; maxHeight?: number; height?: number } = {},
	circle = false,
	error = false,
	disabled = false,
): SxProps<Theme> => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',

	position: 'relative',
	border: src ? 'none' : `0.71px dashed ${error ? Colors.redDark : Colors['7D7D7D80']} ${error ? '!important' : ''}`,

	minWidth: width,
	minHeight: height,
	maxWidth,
	maxHeight,
	aspectRatio: '1/1',

	cursor: disabled ? 'default' : 'pointer',
	userSelect: 'none',
	borderRadius: circle ? '50%' : '2px',

	...(src
		? withWrapper
			? {
					backgroundColor: 'transparent !important',
					background: 'none',
			  }
			: {
					background: `url(${src}) no-repeat center center`,
					backgroundSize: 'cover',
			  }
		: {
				color: 'white',
				fontSize: '24px',
				fontWeight: 'bold',
				backgroundColor: Colors['141414'],
		  }),
});
